<div class="text-center alert background-main-color">
  <i class="fa fa-refresh fa-spin font-size-20"> </i>
  <span> {{ 'LOADING' | translate }}...</span>
</div>